import { takeLatest, put, call } from 'redux-saga/effects';
import { ExercisesTypes, ExercisesAction, Exercise } from '../types';
import { saveExercises, getListExercises, saveExercise, deleteExercise } from '../actions';
import {
    deleteExerciseFirebase,
    getExercisesFirebase,
    saveExerciseFirebase,
    saveExercisesFirebase,
} from '../repository';
import { Stage } from '../../missions/types';
import { requestSaveStage } from '../../missions/actions';
import { requestDeleteTasks } from '../../tasks/actions';

export function* requestGetListExercisesSaga(props: ExercisesAction<{ ids: string[] }>): unknown {
    try {
        const exercises = yield call(getExercisesFirebase, props.payload.ids);
        yield put(getListExercises(exercises));
    } catch (err: unknown) {
        yield put(getListExercises([]));
    }
}

export function* requestSaveExercisesSaga(props: ExercisesAction<{ exercises: Exercise[] }>): unknown {
    try {
        const exercises = yield call(saveExercisesFirebase, props.payload.exercises);
        yield put(saveExercises(exercises));
    } catch (err: unknown) {
        yield put(saveExercises());
    }
}

export function* requestSaveExerciseSaga(
    props: ExercisesAction<{ missionId: string; stage: Stage; exercise: Exercise }>,
): unknown {
    try {
        const exercise = yield call(saveExerciseFirebase, props.payload.exercise);
        yield put(saveExercise(exercise));
        yield put(
            requestSaveStage(
                {
                    ...props.payload.stage,
                    exercises: getNewExercisesList(exercise.id, props.payload.stage.exercises),
                },
                props.payload.missionId,
            ),
        );
    } catch (err: unknown) {
        yield put(saveExercise());
    }
}

const getNewExercisesList = (exerciseId: string, exercises?: string[]) => {
    if (!exercises) return [exerciseId];
    if (exercises.includes(exerciseId)) return exercises;
    return [...exercises, exerciseId];
};

export function* requestDeleteExerciseSaga(props: ExercisesAction<{ id: string; tasks: string[] }>): unknown {
    try {
        const tasks = props.payload.tasks;
        const id = yield call(deleteExerciseFirebase, props.payload.id);
        yield put(deleteExercise(id));
        if (tasks && tasks.length > 0) yield put(requestDeleteTasks(tasks));
    } catch (err: unknown) {
        yield put(deleteExercise());
    }
}

export default [
    takeLatest(ExercisesTypes.REQUEST_GET_LIST_EXERCISES, requestGetListExercisesSaga),
    takeLatest(ExercisesTypes.REQUEST_SAVE_EXERCISES, requestSaveExercisesSaga),
    takeLatest(ExercisesTypes.REQUEST_SAVE_EXERCISE, requestSaveExerciseSaga),
    takeLatest(ExercisesTypes.REQUEST_DELETE_EXERCISE, requestDeleteExerciseSaga),
];
